import styled from 'styled-components';

export const Text = styled.p`
  color: ${({ theme }) => theme.brand.text};
`;
